/**
 * Single source of truth for the app's public base URL.
 *
 * Runtime (browser): always prefer `window.location.origin` so Firebase Hosting
 * aliases (e.g. readyresponder.web.app) and the canonical custom domain both work.
 *
 * Non-browser / build-time fallback: `VITE_PUBLIC_BASE_URL`, then mode defaults.
 * Canonical production origin is https://arevina.com (readyresponder.web.app remains
 * a Hosting alias, not the URL we advertise to third parties).
 */

const PRODUCTION_ORIGIN = 'https://arevina.com';
const STAGING_ORIGIN = 'https://ready-responder---stage.web.app';

function stripTrailingSlash(url: string): string {
  return url.replace(/\/$/, '');
}

export function getPublicBaseUrl(): string {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return stripTrailingSlash(window.location.origin);
  }

  const fromEnv = import.meta.env.VITE_PUBLIC_BASE_URL as string | undefined;
  if (fromEnv?.trim()) {
    return stripTrailingSlash(fromEnv.trim());
  }

  if (import.meta.env.MODE === 'staging') return STAGING_ORIGIN;
  return PRODUCTION_ORIGIN;
}

/** Absolute URL for a path (share links, auth continue URLs, etc.). */
export function publicAbsoluteUrl(path = '/'): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${getPublicBaseUrl()}${normalized}`;
}
